var map = {
	"./Close.svg": "61da",
	"./Inna-logo-big.svg": "3482",
	"./Inna-logo-small.svg": "66ea",
	"./Inna-purple-logo.svg": "7e9a",
	"./Plus.svg": "17fa",
	"./alert.svg": "6c40",
	"./breadcrumb-arrow.svg": "ae5f",
	"./checkmark.svg": "0cdd",
	"./fonts/adellesans-bold-webfont.woff": "bbaf",
	"./fonts/adellesans-bold-webfont.woff2": "0e496",
	"./fonts/adellesans-light-webfont.woff": "f0d6",
	"./fonts/adellesans-light-webfont.woff2": "5482",
	"./fonts/adellesans-regular-webfont.ttf": "f119",
	"./fonts/adellesans-regular-webfont.woff": "3374",
	"./fonts/adellesans-regular-webfont.woff2": "b337",
	"./landing-error.jpg": "3c0e",
	"./landing-loading.jpg": "480e",
	"./logo.png": "cf05",
	"./namskra.svg": "1712",
	"./nemendahald.svg": "bd61",
	"./notandi.svg": "0b84",
	"./right-arrow.svg": "f590",
	"./search.svg": "51f2",
	"./skolahald.svg": "05df",
	"./starfsmannahald.svg": "e89c",
	"./system0.png": "4a18",
	"./system1.png": "ff5f",
	"./system2.png": "b057",
	"./system3.png": "364a",
	"./system4.png": "1b6c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";